import React from 'react';
import { Rect, Group } from 'react-konva';
import { color } from 'styles/settings';

export const iconOffset = 25;

export const iconProps = {
  width: 26,
  height: 26,
  offsetX: iconOffset,
  y: 16,
};

function ContextBar({ icons }) {
  const iconsCount = icons.filter(Boolean).length;

  const width = iconsCount * iconProps.width + iconOffset * (iconsCount + 1);

  return (
    <Group offsetY={100} x={-(width / 2)}>
      <Rect width={width} height={58} fill={color.neutral.white} />
      {icons.filter(Boolean).map((icon, index) =>
        React.cloneElement(icon, {
          key: index,
          x: (iconProps.width + iconOffset) * (index + 1),
        }),
      )}
    </Group>
  );
}

export default ContextBar;
